import { ArrowDownRight, ArrowUpRight, Box, ClipboardCheck, Truck } from "lucide-react";

function MiniTrend({ points }) {
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const path = points
    .map((point, index) => {
      const x = (index / (points.length - 1)) * 100;
      const y = 32 - ((point - min) / range) * 25;
      return `${index === 0 ? "M" : "L"} ${x} ${y}`;
    })
    .join(" ");
  return (
    <svg className="mini-trend" viewBox="0 0 100 36" preserveAspectRatio="none" aria-hidden="true">
      <path d={path} fill="none" stroke="currentColor" strokeWidth="2.2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

export default function CommandCenter({ data }) {
  const metrics = [
    { label: "Inventory value", value: data.inventory_value, detail: data.inventory_change },
    { label: "30-day sell-through", value: data.sell_through, detail: data.sell_through_change },
  ];
  return (
    <aside className="command-center" data-testid="command-center">
      <section className="metric-panel" data-testid="inventory-overview-panel">
        <p className="eyebrow">The business at a glance</p>
        <div className="metric-grid">
          {metrics.map((metric, index) => (
            <div className="metric" data-testid={`metric-${index}`} key={metric.label}>
              <p>{metric.label}</p>
              <strong>{metric.value}</strong>
              <span><ArrowUpRight size={13} strokeWidth={2} /> {metric.detail}</span>
            </div>
          ))}
        </div>
      </section>
      <section className="category-panel" data-testid="category-performance-panel">
        <div className="panel-title-line">
          <div>
            <p className="eyebrow">Where value is moving</p>
            <h2>Category pulse</h2>
          </div>
          <MiniTrend points={[8, 13, 11, 19, 18, 25, 29]} />
        </div>
        <div className="category-list">
          {data.category_data.map((category) => (
            <div className="category-row" data-testid={`category-${category.name.toLowerCase().replaceAll(" ", "-")}`} key={category.name}>
              <div>
                <span className="category-name">{category.name}</span>
                <span className="category-value">{category.value}% of value</span>
              </div>
              <span className={`category-change ${category.direction}`}>
                {category.direction === "up" ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
                {category.change}
              </span>
            </div>
          ))}
        </div>
      </section>
      <section className="operations-panel" data-testid="operations-panel">
        <p className="eyebrow">Keep things moving</p>
        <div className="operation-item" data-testid="shipping-signal">
          <span className="operation-icon"><Truck size={18} strokeWidth={1.8} /></span>
          <div>
            <h3>{data.shipping.ready} orders ready to ship</h3>
            <p>{data.shipping.late_risk} at late-delivery risk · cutoff {data.shipping.cutoff}</p>
          </div>
        </div>
        <div className="operation-item" data-testid="grading-signal">
          <span className="operation-icon"><Box size={18} strokeWidth={1.8} /></span>
          <div>
            <h3>{data.grading.at_psa} cards with PSA</h3>
            <p>Expected {data.grading.expected} · {data.grading.ready_to_list} now ready to list</p>
          </div>
        </div>
        <div className="operation-item" data-testid="intake-signal">
          <span className="operation-icon"><ClipboardCheck size={18} strokeWidth={1.8} /></span>
          <div>
            <h3>{data.intake.count} deals awaiting a decision</h3>
            <p>{data.intake.value} open capital · {data.intake.next}</p>
          </div>
        </div>
      </section>
    </aside>
  );
}